import { Typography } from "@mui/material";
import React from "react";
import Nabvar from "../../common/Nabvar";
import Sidebar from "../../common/Sidebar";

import Edit from "./Edit";
export default function Editkacoupon() {

  return (
    <>
      {/* navigation section */}
      <Sidebar />
      <Nabvar />

      {/* body */}
      <section
      style={{width:"75vw",float:"right",marginTop:"10vh"}}
      >
        <Typography style={{ color: "#646777", fontWeight: "800" }}>Edit Coupon</Typography>
        <Edit />

      </section>
    </>
  );
}
